<template>
  <div class="col-md-12 ">

    <div class="row">
      <div class="col-md-12 ">
        <div class="row">
          <div  class="col-md-8">
            <div class="row">
              <div class="col-sm-12" >
                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">
                        <label class="control-label">RT # {{number}}</label>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="control-label">Cliente: {{clientName}}</label>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                        <label class="control-label">Fecha: {{created_at}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-md-8">
        
        <div v-if="invoices.length>0">
          <br>
          <label>Comprobantes asociados:</label>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Numero</th>
                <th class="table-danger">Importe</th>
                <th class="table-danger">En Recibo</th>
                <th class="table-danger">Ver Detalle</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(invoice, index) in invoices" :key="index">
                <td>{{ invoice.type }}</td>
                <td>{{ invoice.number }}</td>
                <td class="table-danger">{{ invoice.total }}</td>
                <td class="table-danger">{{ invoice.partial }}</td>
                <td class="table-danger">
                  <a :href="`/ventas/index/detalle/${invoice.id}`" class="btn btn-sm btn-light">Ver detalle</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
       
      </div>
      
      <div class="col-md-4 visible-md visible-lg">
        <div data-spy="affix" data-offset-top="200" class="panel panel-default affix-top">
          <div class="panel-heading">
            <h2 class="panel-title">Total </h2>
          </div>
          <div class="panel-body">
            <ul class="list-unstyled totals">
           
              <li>
                <div class="row">
                  <div class="col-xs-7">
                    TOTAL:
                  </div>
                  <div class="col-xs-5 text-right">
                    $ <span id="htmlTotal">{{withholding.amount}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col mt-3">
        <DownloadDoc :pdfurl="pdfurl" :open="true" :filename="withholding.client.name+withholding.created_at+'.pdf'">
          <button type="button" class="btn btn-orange btn-lg">Imprimir</button>
        </DownloadDoc>
      </div>
      <div class="col mt-3">
        <DownloadDoc :pdfurl="pdfurl" :open="false" :filename="withholding.client.name+withholding.created_at+'.pdf'">
          <button type="button" class="btn btn-orange btn-lg">Descargar</button>
        </DownloadDoc>
      </div>
    </div>


  </div>

</template>
<script>
import DownloadDoc from "../global/DownloadDoc";

export default {
  components: {
    DownloadDoc
  },
  props: ['withholding','invoices'],
 
  data() {
    return {
      pdfurl: process.env.VUE_APP_BASE_URL+'/api/collections/recPDF/' + this.withholding.id,
    }
  },
  computed:{
    number() { return this.withholding.id },
    clientName() { return this.withholding.client != undefined?this.withholding.client.name :''},
    created_at() { return this.withholding.created_at },
  },
}
</script>